export const TransferRecipientAccountTypeEnum = {
  Deposit: 'Deposit',
  Savings: 'Savings',
  Card: 'Card',
  Iban: 'Iban',
  Other: 'Other',
} as const;
export type TransferRecipientAccountTypeEnum = (typeof TransferRecipientAccountTypeEnum)[keyof typeof TransferRecipientAccountTypeEnum];
